export const listingManager = {
  header: {
    title: "Inserate",
    newListingTitle: "Neues Inserat",
    reorderExit: "Sortiermodus beenden",
    reorder: "Inserate sortieren",
    done: "Fertig",
    sort: "Sortieren",
    searchPlaceholder: "Suchen…",
    searchClear: "Löschen",
    reorderHint: "Zum Ändern der Reihenfolge ziehen",
  },
  globalBtn: {
    title: "Globale Einstellungen",
    sub: "Identität und neue Buchungen · gesamtes Konto",
  },
  list: {
    of: "von",
    listingSingular: "Inserat",
    listingPlural: "Inserate",
    unitSingular: "Einheit",
    unitPlural: "Einheiten",
    retry: "Erneut versuchen",
    noResults: 'Keine Ergebnisse für "{query}"',
    viewUnits: "Einheiten anzeigen",
    loadingUnits: "Einheiten werden geladen…",
    refuerzaA: "Unterstützt {name}: übernimmt vorerst dessen Kanalbuchungen",
    noUnits: "Keine Einheiten",
    dragToMove: "Zum Verschieben ziehen",
    unitFallback: "Einheit {n}",
  },
  empty: {
    title: "Inserat auswählen",
    sub: "Wählen Sie links ein Inserat aus, um dessen Einstellungen zu verwalten.",
  },
  create: {
    title: "Neues Inserat",
    subtitle: "Erstellen Sie ein Inserat, um Ihre Einheiten zu gruppieren.",
    nameLabel: "Name des Inserats",
    namePlaceholder: "Z. B. Loft im Zentrum",
    typeLabel: "Unterkunftsart",
    currencyLabel: "Währung",
    currencyHint: "Die Währung kann nach dem Erstellen des Inserats nicht mehr geändert werden.",
    submit: "Inserat erstellen",
    nameRequired: "Der Name ist erforderlich.",
    errorCreate: "Das Inserat konnte nicht erstellt werden.",
    successCreate: "Inserat erfolgreich erstellt.",
  },
  delete: {
    titleListing: "Inserat löschen",
    titleUnit: "Einheit löschen",
    text: "Es wird aus WACheckin entfernt. Diese Änderungen können nicht rückgängig gemacht werden. Geben Sie zur Bestätigung den Namen ein:",
    placeholderListing: "Name des Inserats",
    placeholderUnit: "Name der Einheit",
    deleting: "Wird gelöscht…",
    confirm: "Löschen",
    errorDelete: "Löschen nicht möglich.",
    successListing: "Inserat erfolgreich gelöscht.",
    successUnit: "Einheit erfolgreich gelöscht.",
  },
  propertyTypes: {
    apartment: "Apartment",
    villa: "Villa",
    hotel: "Hotel",
    camping: "Camping",
  },
  propertyTypeLabels: {
    apartment: "Apartment",
    house: "Haus",
    villa: "Villa",
    hotel: "Hotel",
    room: "Zimmer",
    studio: "Studio",
    fallback: "Unterkunft",
  },
  toast: {
    errorLoad: "Fehler beim Laden der Inserate.",
    orderSaved: "Reihenfolge erfolgreich gespeichert.",
    errorOrder: "Die Reihenfolge konnte nicht gespeichert werden.",
    nameUpdated: "Name aktualisiert.",
    errorName: "Der Name konnte nicht aktualisiert werden.",
  },
  common: {
    cancel: "Abbrechen",
  },
  globalConfig: {
    hero: {
      title: "Globale Einstellungen",
      subPre: "Einstellungen des KI-Agenten für",
      subStrong: "alle Ihre Unterkünfte",
      subPost: ".",
    },
    waba: {
      checking: "Verbindung wird geprüft…",
      connected: "Verbunden",
      start: "Hier starten",
      titleConnected: "WhatsApp Business",
      titleDisconnected: "WhatsApp Business verbinden",
      checkingSub: "Status Ihrer Nummer wird geprüft…",
      numberPrefix: "Nummer",
      verified: "verifiziert und sendebereit ✓",
      pending: "Verifizierung ausstehend",
      linked: "Ihr WhatsApp Business-Konto ist verknüpft.",
      linkPrompt: "Verknüpfen Sie Ihre Nummer, damit der Agent Ihren Gästen auf WhatsApp antworten und schreiben kann.",
      manage: "Verwalten",
      connect: "Verbinden",
    },
    sectionLabel: "Allgemein · gesamtes Konto",
    badgeDefault: "KI ✨",
    requiresWaba: "Erfordert eine WhatsApp Business-Verbindung",
    notContracted: "Nicht in Ihrem Tarif enthalten. Kontaktieren Sie uns zur Aktivierung.",
    cards: {
      general: {
        title: "Allgemeine Einstellungen",
        sub: "Identität und Stil des Agenten",
      },
      newBookings: {
        title: "Neue Buchungen",
        sub: "Erstkontakt, Fragen und Buchungslink",
      },
      voiceAgent: {
        title: "KI-Sprachagent",
        sub: "Beantwortet Telefonanrufe",
        badge: "NEU",
      },
    },
    foot: {
      pre: "Diese Einstellungen gelten",
      strong: "nur für Ihr Konto",
      post: ": Änderungen hier werden automatisch auf alle Inserate angewendet. Die übrige Konfiguration (Check-in, Zugang, Preise…) bleibt pro Inserat.",
    },
  },
};
